// MySQL / MariaDB version gating for CTE support (PRD Slice "MySQL Resolver
// — CTEs + Subqueries").
//
// CTEs were introduced in MySQL 8.0 and MariaDB 10.2. On older servers any
// `WITH …` clause is a syntax error, so the resolver suppresses CTE
// candidates (FROM-position CTE name suggestions and CTE alias-dot column
// lookups) when the server version is below the threshold.
//
// `serverVersion` strings observed in practice:
//   • MySQL: '8.0.34', '5.7.40', '5.6.51', '8.4.0', etc.
//   • MariaDB: '10.11.6-MariaDB', '10.5.21-MariaDB-log', '10.2.44-MariaDB',
//             '10.0.38-MariaDB', etc.
//
// The cache returns `''` (empty string) when the introspection probe failed
// — fail-open and assume CTE support, since a wrong "supported" decision
// only over-emits candidates while a wrong "unsupported" decision suppresses
// genuinely useful suggestions.

export function cteSupportedForServerVersion(
  serverVersion: string | undefined,
): boolean {
  if (!serverVersion) return true;
  const trimmed = serverVersion.trim();
  if (trimmed === '') return true;

  if (/MariaDB/i.test(trimmed)) {
    const m = /^(\d+)\.(\d+)/.exec(trimmed);
    if (!m) return true;
    const major = Number(m[1]);
    const minor = Number(m[2]);
    if (major > 10) return true;
    if (major === 10 && minor >= 2) return true;
    return false;
  }

  const m = /^(\d+)\./.exec(trimmed);
  if (!m) return true;
  const major = Number(m[1]);
  return major >= 8;
}
